module.exports = __webpack_public_path__ + "img/European_Union.7fb11c39.svg";